import { UseQueryResult, useQuery } from "react-query";
import { getVehicleHistoryInformation } from "store/api/api";
import { QUERY_KEYS } from "../queryKeys";

type Params = {
  fleetId: string | null;
  vehicleId: string | null;
  enabled?: boolean;
};

const getVehicleHistoryInformationResult = async (
  fleetId: string,
  vehicleId: string
) => {
  try {
    const res = await getVehicleHistoryInformation(fleetId, vehicleId);

    return res?.data;
  } catch (error) {
    return [];
  }
};

export function useGetVehicleHistoryInformation({
  fleetId,
  vehicleId,
  enabled,
}: Params): UseQueryResult<any[]> {
  return useQuery(
    [QUERY_KEYS.vehicleHistoryInformation, fleetId, vehicleId],
    () => getVehicleHistoryInformationResult(fleetId, vehicleId),
    {
      refetchOnMount: true,
      enabled: enabled,
      staleTime: 0, // Data is immediately stale
      cacheTime: 0, // Remove from cache immediately
    }
  );
}
